import React, {useState} from 'react';
import {DragIndicatorRounded} from '@mui/icons-material';
import {DndContext, closestCenter, DragOverlay, KeyboardSensor, PointerSensor, useSensor, useSensors} from '@dnd-kit/core';
import {arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

const SortableSection = ({section}) => {
    const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id: section.key});
    const style = {transform: CSS.Transform.toString(transform), transition};
    const wrapperClass = ['ch-lesson-plan-sortable-section', isDragging ? 'ch-lesson-plan-sortable-section--dragging' : ''].filter(Boolean).join(' ');
    const cardClass = ['ch-lesson-plan-section-card', isDragging ? 'ch-lesson-plan-section-card--ghost' : ''].filter(Boolean).join(' ');

    return (
        <div ref={setNodeRef} style={style} className={wrapperClass}>
            <div className={cardClass} {...attributes} {...listeners}>
                <span className="ch-lesson-plan-drag-handle">
                    <DragIndicatorRounded style={{fontSize: '20px'}} />
                </span>
                <span className="ch-lesson-plan-section-card-label">{section.label}</span>
            </div>
        </div>
    );
};

const SortableSectionList = ({sections, sectionOrder, onOrderChange}) => {
    const [activeId, setActiveId] = useState(null);

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {coordinateGetter: sortableKeyboardCoordinates}),
    );

    const onDragEnd = ({active, over}) => {
        setActiveId(null);
        if (!over || active.id === over.id) return;
        onOrderChange(prev => arrayMove(prev, prev.indexOf(active.id), prev.indexOf(over.id)));
    };

    const orderedSections = sectionOrder.map(key => sections.find(s => s.key === key));
    const activeSection = activeId ? sections.find(s => s.key === activeId) : null;

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            autoScroll={{threshold: {x: 0, y: 0.05}}}
            onDragStart={({active}) => setActiveId(active.id)}
            onDragEnd={onDragEnd}
            onDragCancel={() => setActiveId(null)}
        >
            <SortableContext items={sectionOrder} strategy={verticalListSortingStrategy}>
                {orderedSections.map(section => (
                    <SortableSection key={section.key} section={section} />
                ))}
            </SortableContext>
            <DragOverlay>
                {activeSection ? (
                    <div className="ch-lesson-plan-section-card ch-lesson-plan-section-card--floating">
                        <span className="ch-lesson-plan-drag-handle">
                            <DragIndicatorRounded style={{fontSize: '20px'}} />
                        </span>
                        <span className="ch-lesson-plan-section-card-label">{activeSection.label}</span>
                    </div>
                ) : null}
            </DragOverlay>
        </DndContext>
    );
};

export default SortableSectionList;
